/** @jsxImportSource @emotion/react */

import React from 'react';
import { useVisible } from 'react-hooks-visible';
import { animated, useSpring } from 'react-spring';
import { AnimatedDelightProps } from './IAnimatedDelightProps';

export const AnimatedDelightLeft = ({ endScale = 1, startScale = 0 }: AnimatedDelightProps) => {
  const [targetRef, isVisible] = useVisible((vi: number) => vi > 0.9);
  const style1 = useSpring({
    to: {
      transform: isVisible ? `scale3d(${endScale}, ${endScale}, ${endScale})` : `scale3d(${startScale}, ${startScale}, ${startScale})`
    },
    from: {
      transform: `scale3d(${startScale}, ${startScale}, ${startScale})`
    },
    delay: 300,
    config: {
      tension: 400,
      friction: 20
    }
  });

  const style2 = useSpring({
    to: {
      transform: isVisible ? `scale3d(${endScale}, ${endScale}, ${endScale})` : `scale3d(${startScale}, ${startScale}, ${startScale})`
    },
    from: {
      transform: `scale3d(${startScale}, ${startScale}, ${startScale})`
    },
    delay: 400,
    config: {
      tension: 400,
      friction: 20
    }
  });

  const style3 = useSpring({
    to: {
      transform: isVisible ? `scale3d(${endScale}, ${endScale}, ${endScale})` : `scale3d(${startScale}, ${startScale}, ${startScale})`
    },
    from: {
      transform: `scale3d(${startScale}, ${startScale}, ${startScale})`
    },
    delay: 500,
    config: {
      tension: 400,
      friction: 20
    }
  });

  const style4 = useSpring({
    to: {
      transform: isVisible ? `scale3d(${endScale}, ${endScale}, ${endScale})` : `scale3d(${startScale}, ${startScale}, ${startScale})`
    },
    from: {
      transform: `scale3d(${startScale}, ${startScale}, ${startScale})`
    },
    delay: 600,
    config: {
      tension: 400,
      friction: 20
    }
  });

  const style5 = useSpring({
    to: {
      transform: isVisible ? `scale3d(${endScale}, ${endScale}, ${endScale})` : `scale3d(${startScale}, ${startScale}, ${startScale})`
    },
    from: {
      transform: `scale3d(${startScale}, ${startScale}, ${startScale})`
    },
    delay: 700,
    config: {
      tension: 400,
      friction: 20
    }
  });

  return (
    <div
      css={{
        height: '100%',
        left: '0',
        position: 'absolute',
        top: '300px',
        zIndex: -1
      }}
    >
      <svg
        css={{
          display: 'none',

          [`@media (min-width: 1050px)`]: {
            display: 'block',
            height: '290px',
            position: 'sticky',
            top: '500px',
            width: '245px',
          }
        }}
        ref={targetRef as any}
        viewBox="0 0 245 290"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <animated.path
          css={{
            transformOrigin: '98px 13px'
          }}
          style={style1}
          id="mod-left-1"
          d="M93.274.958c-6.642 2.556-9.961 10.023-7.414 16.676 2.547 6.654 9.996 9.976 16.638 7.419 6.642-2.557 9.961-10.023 7.414-16.677-2.547-6.654-9.996-9.975-16.638-7.418z"
          fill="#6DAFB8"
        />
        <animated.path
          css={{
            transformOrigin: '33px 111px'
          }}
          style={style2}
          id="mod-left-2"
          d="M15.845 133.938c12.526 10.164 30.91 8.221 41.061-4.339 10.151-12.561 8.225-30.982-4.301-41.146-12.527-10.164-30.91-8.221-41.062 4.339-10.15 12.56-8.225 30.982 4.302 41.146z"
          stroke="#D7E100"
          strokeWidth="10"
        />
        <animated.g
          css={{
            transformOrigin: '183px 118px'
          }}
          style={style5}
          id="mod-left-3"
        >
          <path
            d="M208.845 100.007a6.884 6.884 0 00-3.325 9.136 6.852 6.852 0 009.118 3.319l20.201-9.445a6.884 6.884 0 003.325-9.136 6.852 6.852 0 00-9.118-3.319l-20.201 9.445z"
            fill="#E43896"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M125.825 95.96c1.271-3.492 5.122-5.294 8.604-4.027l23.828 8.673c3.478 1.266 5.271 5.121 4.004 8.611l-.002.005c-1.271 3.493-5.122 5.295-8.604 4.028l-23.828-8.673c-3.478-1.266-5.271-5.121-4.004-8.61l.002-.006zM207.817 125.626c1.271-3.492 5.122-5.295 8.604-4.028l23.828 8.673c3.478 1.266 5.271 5.121 4.004 8.611l-.002.005c-1.271 3.493-5.122 5.296-8.604 4.028l-23.828-8.673c-3.478-1.266-5.271-5.121-4.004-8.611l.002-.005z"
            fill="#E43896"
          />
          <path
            d="M133.419 137.149a6.884 6.884 0 00-3.326 9.136 6.852 6.852 0 009.118 3.319l20.201-9.444a6.886 6.886 0 003.326-9.137 6.851 6.851 0 00-9.118-3.318l-20.201 9.444z"
            fill="#E43896"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M204.541 59.177c-3.48-1.266-7.328.535-8.598 4.025l-8.691 23.881c-1.269 3.486.519 7.34 3.993 8.608l.006.001c3.479 1.267 7.327-.535 8.597-4.024l8.691-23.882c1.269-3.485-.519-7.34-3.993-8.607l-.005-.002zM177.226 139.911c-3.48-1.266-7.327.535-8.598 4.025l-8.691 23.881c-1.269 3.486.519 7.34 3.993 8.608l.006.002c3.479 1.266 7.327-.535 8.597-4.025l8.692-23.881c1.268-3.486-.52-7.34-3.994-8.608a.008.008 0 01-.005-.002zM159.947 64.042a6.851 6.851 0 019.118 3.32l9.423 20.26c1.6 3.439.111 7.53-3.325 9.136a6.853 6.853 0 01-9.119-3.32l-9.423-20.26a6.884 6.884 0 013.326-9.136zM194.392 138.06a6.85 6.85 0 019.118 3.319l9.423 20.259a6.885 6.885 0 01-3.325 9.137 6.852 6.852 0 01-9.119-3.319l-9.423-20.26a6.884 6.884 0 013.326-9.136z"
            fill="#E43896"
          />
        </animated.g>
        <animated.path
          css={{
            transformOrigin: '81px 233px'
          }}
          style={style4}
          id="mod-left-4"
          d="M74.64 216.702c-9.299 3.579-13.946 14.032-10.38 23.347 3.566 9.315 13.994 13.965 23.293 10.386 9.299-3.579 13.946-14.032 10.38-23.348-3.566-9.315-13.995-13.965-23.293-10.385z"
          stroke="#E43896"
          strokeWidth="10"
        />
        <animated.path
          css={{
            transformOrigin: '188px 265px'
          }}
          style={style3}
          id="mod-left-5"
          d="M179.524 242.367c-12.398 4.772-18.594 18.709-13.84 31.13 4.755 12.42 18.66 18.62 31.058 13.847 12.398-4.772 18.595-18.71 13.84-31.13-4.754-12.42-18.659-18.62-31.058-13.847z"
          fill="#F46508"
        />
      </svg>
    </div>
  );
};
